import React from 'react'
import {useState} from 'hooks'
import {uuidv4} from 'utils'

export const ModalContext = React.createContext<any>({})
export const ModalInstanceContext = React.createContext<any>({})

function useModalState() {
	const [stack, setStack] = useState<any>({})

	const open = (component: any, props: any = {}) => {
		const id = uuidv4()
		setStack({
			...stack,
			[id]: {
				component,
				props,
				isOpen: true
			}
		})

		return id
	}

	const close = (id: any) => {
		setStack({
			...stack,
			[id]: {
				...stack[id],
				isOpen: false
			}
		})
	}

	const update = (id: any, props: any = {}) => {
		const nextStack: any = {}
		for (const [key, value] of Object.entries(stack)) {
		  if (key === id) {
		  	nextStack[key] = {
		  		...(value as any),
		  		props
		  	}
		  }
		  else {
				nextStack[key] = value
		  }
		}

		setStack(nextStack)
	}

	const unmount = (id: any) => {
		const {[id]:_, ...nextStack} = stack
		setStack(nextStack)
	}

	return {
		stack,
		open,
		update,
		close,
		unmount
	}
}

export function ModalProvider({children}: any) {

	const state = useModalState()

	return (
		<ModalContext.Provider value={state}>
			{children}
		</ModalContext.Provider>
	)
}

export function ModalInstanceProvider({children, ...value}: any)
{
	return (
		<ModalInstanceContext.Provider value={value}>
			{children}
		</ModalInstanceContext.Provider>
	)
}
